import DropdownTemplateView from '../DropdownTemplateView'
import $ from 'jquery'

class AnimatedDialogWrapper extends DropdownTemplateView {
    constructor($el, {
        dialog,
        className,
        keyFrameClass = null,
        onHide = () => {},
        preventHide = () => false,
        autoPosition = false,
        toggleMode = false,
    }) {
        super($el, {
            toggleMode: toggleMode,
        })

        this.params = {
            dialog,
            className,
            onHide,
            keyFrameClass,
            preventHide,
            autoPosition,
        }
    }

    shouldUpdateOnInit() {
        return false
    }

    templateHtml() {
        return '<div class="panelAnimatedDialogWrapper <%=className%>"></div>'
    }

    templateModel() {
        return {
            ...this.params
        }
    }

    onHide() {
        super.onHide()
        this.params.onHide()
        this.applyForChildrenComponents(c => c.hide())
    }

    update() {
        super.update()
        this.applyForChildrenComponents(child => child.update())
    }

    afterRender() {
        this.params.dialog.init(this.$el).hide()
        this.registerChildComponents(this.params.dialog)
    }

    showAt($el, positionParams = {}, $positionEl) {
        super.showAt(
            $el,
            {
                my: 'right top',
                at: 'right top',
                ...positionParams
            },
            $positionEl
        )
    }

    _showElementAt($el, pos) {
        if (this.params.autoPosition) {
            super._showElementAt($el, pos)
        }
    }

    mouseDownTargetElement() {
        return $('body')
    }

    _isPossibleToHide() {
        let possible = !this.params.preventHide()

        if (this.params.dialog.closeable !== undefined) {
            possible = possible && this.params.dialog.closeable()
        }

        return possible
    }

    show() {
        this.resumeHandlingStateChanges()
        if (this.params.keyFrameClass !== null) {
            this.$el.removeClass(this.params.keyFrameClass)
            this.$el.show()
            this.$el.atAnimation().oneAnimationEnd(() => {
                if (this.isShown) {
                    this.applyForChildrenComponents(child => child.show())
                    this.applyForChildrenComponents(child => child.update())
                }
            })
            this.$el.addClass(this.params.keyFrameClass)
        } else {
            this.$el.show()
            this.applyForChildrenComponents(child => child.show())
        }
    }

    setState(data) {
        super.setState(data)
        this.applyForChildrenComponents(child => child.setState(data))
    }
}

export default AnimatedDialogWrapper



// WEBPACK FOOTER //
// ./web/js/util/AnimatedDialogWrapper.js